import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

import './score.css';

export default class Score extends Component {

    render() {
      return (
        <div className='score-bar__score score-bar__score--score'>
          <CSSTransitionGroup transitionName='score-animation' transitionEnterTimeout={1100} transitionLeave={false}>
            <p key={this.props.score}>{this.props.label}: {this.props.score}</p>
          </CSSTransitionGroup>
        </div>
      );
    }
}

Score.propTypes = {
  score: PropTypes.number,
  label: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/components/score/score.js